// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectObjects__container___RhBy1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 32rem;

    border-right: 0.1rem solid var(--color-bg-border);
}

.ProjectObjects__right___sX3b_ {
    display: flex;
    align-items: center;
}

.ProjectObjects__findText___g61Vb {
    margin-top: 0.8rem;
}

.ProjectObjects__treeBarCollapseTab___gNpHy {
    border-top: 0.1rem solid var(--color-bg-border);
}

.ProjectObjects__objectsPropertiesChoiceGroup___Rw0WO {
    display: flex;
    flex-grow: 1;
    margin-bottom: 2rem;
}

.ProjectObjects__title___sObAc {
    padding: var(--space-xs);
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/ProjectObjects/ProjectObjects.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;;IAE9B,YAAY;;IAEZ,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    width: 32rem;\n\n    border-right: 0.1rem solid var(--color-bg-border);\n}\n\n.right {\n    display: flex;\n    align-items: center;\n}\n\n.findText {\n    margin-top: 0.8rem;\n}\n\n.treeBarCollapseTab {\n    border-top: 0.1rem solid var(--color-bg-border);\n}\n\n.objectsPropertiesChoiceGroup {\n    display: flex;\n    flex-grow: 1;\n    margin-bottom: 2rem;\n}\n\n.title {\n    padding: var(--space-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ProjectObjects__container___RhBy1`,
	"right": `ProjectObjects__right___sX3b_`,
	"findText": `ProjectObjects__findText___g61Vb`,
	"treeBarCollapseTab": `ProjectObjects__treeBarCollapseTab___gNpHy`,
	"objectsPropertiesChoiceGroup": `ProjectObjects__objectsPropertiesChoiceGroup___Rw0WO`,
	"title": `ProjectObjects__title___sObAc`
};
export default ___CSS_LOADER_EXPORT___;
